import { combineActions, handleActions } from 'redux-actions';
import { pricing as actions } from '../../../actions';

const initialState = {
  isFetchingPricing: true,
  pricing: {},
  isPricingError: false,
};

const pricing = handleActions<any, any>({
  [combineActions(
    actions.getPricing,
    actions.receivePricing,
    actions.getPricingFailure,
  ) as any]: (state: any, action: any): any => ({
    ...state,
    ...action.payload,
  }),
}, initialState);

export default pricing;
